/** @module molLazyPlatformViewer - it is used to control the initialization sequience for the platform viewer, and to control it (switching to fullscreen, changing the active picture),
 * and to have ability to programmatically start the init procedure, change the start index of the viewer, or change the config for he viewer.*/
define([
    'require',
    'jquery'
], function(require, $) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'molLazyPlatformViewer';
// Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function() {
            var self = this;

            console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            // Initialize events
            self.events();

            // Do any DOM manipulation or other setup
            self._build();

            // Allow JQuery-style chaining of the plugin
            return self;
        },
        /**
         * Start initialization procedure of the module, load the scene7 viewer wrapper app,
         * @param {number} index - The index that the viewer will shows as selected
         * @param {function} fullScreenChangeCallback - A callback that is called when the fullscreen state is changed
         * @returns {void}
         */
        initViewer: function (index, fullScreenChangeCallback) {
            var self = this;
            this.selector.addClass(this.className);

            require(['vfdp-s7-viewer.app'], function (app) {
                var defaultConfig = {
                    media:{set:{index:index}}
                };
                if( self.showOnlySpinViewer ){
                    defaultConfig.singleViewerMode = true;
                    defaultConfig.singleViewerType = 'SPIN_SET';
                }
                else{
                    defaultConfig.singleViewerMode = false;
                    defaultConfig.singleViewerType = '';
                }
                arguments[0](
                    defaultConfig
                );
                self.viewerInstance = self.element.VFDPS7Viewer;
                if( self.viewerInstance ){
                    if( self.viewerInstance.subscribeToFullScreenChange){
                        self.viewerInstance.subscribeToFullScreenChange(fullScreenChangeCallback);
                    }
                }

            });
            this.isLoaded = true;
        },
        /**
         * Load viewer (shows it if it is hidden, and optionally change the showed index.
         * The viewer shall be initialized before this is called
         * @param {number} index - The index that the viewer will shows as selected
         * @param {boolean} showFullScreen - Show viewer in fullscreen mode
         * @returns {void}
         **/
        loadViewer: function (index, showFullScreen) {
            var self = this;
            if( self.viewerInstance){
                self.viewerInstance.updateMediaSetIndex(index);
                if (showFullScreen) {
                    self.showViewer();
                    self.viewerInstance.onClickFullScreen();
                }
            }
        },
        unloadViewer: function () {
            this.selector.removeClass(self.className);
        },
        hideViewer: function () {
            if( !this.showOnlySpinViewer ){
                this.selector.addClass('hide');
            }
        },
        showViewer: function () {
            this.selector.removeClass('hide');
        },
        moveToContainer: function ($container) {
            this.showOnlySpinViewer = true;
            this.selector.appendTo($container);
            if (this.viewerInstance) {
                this.viewerInstance.changeViewerMode.call(this.viewerInstance, true, 'SPIN_SET');
                var event = {s7event: {asset: this.viewerInstance.mediasetDesc}};
                this.viewerInstance.onMediaSetParsed(event);
            }
        },
        restoreContainer: function ($container) {
            this.showOnlySpinViewer = false;
            this.selector.insertAfter($container);
            var event = {s7event: {asset: this.viewerInstance.mediasetDesc}};
            this.viewerInstance.changeViewerMode.call(this.viewerInstance,false, '');
            this.viewerInstance.onMediaSetParsed(event);
        },

        /**
         * Binds plugin events
         **/
        events: function() {
            var self = this;
            // create event listeners here
        },

        /**
         * Modifies the DOM to support layout requirements
         **/
        _build: function() {
            var self = this;
            self.selector = $(self.element);
            self.className = self.selector.data('viewer');
            self.isLoaded = false;
        }
    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
